import L from 'leaflet'
import {Dialog} from 'primereact/dialog'
import {
    forwardRef,
    useCallback,
    useImperativeHandle,
    useMemo,
    useState,
} from 'react'
import {MapContainer, Marker, Popup, TileLayer} from 'react-leaflet'
import TranslateUtils from '../../i18n/TranslateUtils'
import {
    blockOverflownScroll,
    unblockOverflownScroll,
} from '../../utils/BlockScrollsUtils'

const Map = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        showForm: handleShowForm,
        hideForm: handleHideForm,
    }))
    const {translateCommons} = TranslateUtils()
    const [longitude, setLongitude] = useState(null)
    const [latitude, setLatitude] = useState(null)
    const [visible, setVisible] = useState(false)

    const handleShowForm = useCallback(({longitude, latitude}) => {
        blockOverflownScroll()
        setLongitude(!!longitude || longitude === 0 ? longitude : null)
        setLatitude(!!latitude || latitude === 0 ? latitude : null)
        setVisible(
            (!!longitude || longitude === 0) && (!!latitude || latitude === 0),
        )
    }, [])

    const handleHideForm = useCallback(() => {
        unblockOverflownScroll()
        setLongitude(null)
        setLatitude(null)
        setVisible(false)
    }, [])

    const position = useMemo(() => {
        if ((!longitude && longitude !== 0) || (!latitude && latitude !== 0)) {
            return []
        }
        return [latitude, longitude]
    }, [longitude, latitude])

    const iconMarker = L.icon({
        iconUrl: require('../../assets/icons/locationMarker.png'),
        iconSize: [40, 40],
        iconAnchor: [12, 12],
        popupAnchor: [0, 0],
    })

    return (
        <Dialog
            header={
                <h5 className="mb-0 font-bold">
                    <strong>{translateCommons('Location')}</strong>
                </h5>
            }
            visible={visible}
            blockScroll
            onHide={() => handleHideForm()}
            style={{width: '40vw'}}
            breakpoints={{'960px': '75vw', '641px': '100vw'}}>
            <div style={{minHeight: '50vh', maxHeight: '70vh', zIndex: 99999}}>
                {position && position?.length === 2 && (
                    <MapContainer
                        center={position}
                        zoom={13}
                        style={{width: '100%', height: '50vh'}}
                        scrollWheelZoom={true}>
                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />

                        <Marker position={position} icon={iconMarker}>
                            <Popup>
                                <span>{translateCommons('You are here')}</span>
                            </Popup>
                        </Marker>
                    </MapContainer>
                )}
            </div>
        </Dialog>
    )
})

export default Map
